module.exports = __webpack_public_path__ + "img/user_512x512.e88004e7.png";